import type { Database } from "@excel-center/supabase";
import { z } from "zod";

type DBUserRole = Database["public"]["Enums"]["user_role"];

export const UserRole = {
	GUEST: "guest",
	STUDENT: "student",
	STAFF: "staff",
	ADMIN: "admin",
	SUPER_ADMIN: "super_admin",
} as const satisfies Record<string, DBUserRole>;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

type _EnsureAllDBValues = Exclude<DBUserRole, UserRole> extends never ? true : never;
const _check: _EnsureAllDBValues = true;
void _check;

export const USER_ROLES = Object.values(UserRole) as readonly UserRole[];

export const userRoleSchema = z.enum(UserRole);
